<template>
  <section class="content">
    <div class="warning-block">
      <span class="text-red">＊</span>
      黑名單管理功能已搬至「
      <a @click="goto" class="cursor-pointer">訂單管理 > 黑名單</a>
      」，請至新後台管理系統操作、檢視相關內容，此區域(舊後台)功能即將關閉。
    </div>
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <!--<div class="col-md-12" v-if="getRoleType === 99">-->
        <!--<div class="box">-->
          <!--<div class="box-header">-->
            <!--<h3 class="box-title">例外訂單列表</h3>-->
          <!--</div>-->
          <!--<div class="box-body">-->
            <!--<order-exception-table />-->
            <!--&lt;!&ndash; /.box-body &ndash;&gt;-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
      <div class="col-md-12">
        <div class="box">
          <!--<div class="box-header">-->
            <!--<h3 class="box-title">黑名單訂單列表</h3>-->
          <!--</div>-->
          <!-- /.box-header -->
          <div class="box-body">
            <order-table />
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { setSharedToken } from '../../../assets/js/shared-token.js'
import orderTableTemp from './Temp/BlackListTableTemp.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Tables',
  components: {
    'order-table': orderTableTemp
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    }
  },
  methods: {
    goto () {
      setSharedToken(window.localStorage.getItem(this.$config.token))
      window.location.href = `${this.$config.bdms}order-manage/black-list`
    }
  }
}
</script>

<style scpoed>
/* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte.

@import url('/static/js/plugins/datatables/jquery.dataTables.min.css');
*/

@import url('/static/js/plugins/datatables/dataTables.bootstrap.css');
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}
@media screen and (min-width: 768px) {
  .search-bar {
    max-width: calc( 100% - 98px)
  }
  .form-inline .form-group {
    margin-bottom: 15px !important;
  }
}
.search-bar .input-group input{
  border-radius: 3px 0px 0px 3px !important;
}
.search-bar .input-group span{
  border-radius: 0px 3px 3px 0px !important;
}
</style>



// WEBPACK FOOTER //
// BlackListTable.vue?023243b3